// Internal Imports
import {
  clickReceiverAttribute,
  generateLoadAttribute,
  rootContainerAttribute,
} from './lazyLoadEmbeds.js';
import { classNamesMap } from './youtube.styles.js';

// Local Variables
const autoplayQueryParameter = 'autoplay';
const autoplayQueryParameterActive = `${autoplayQueryParameter}=1`;
const youtubeEmbedRegex = /https:\/\/(?:www\.)?youtube\.com\/embed\/([^?]+)/;

// Local Functions
const isYoutubeEmbedLink = (url) => Boolean(youtubeEmbedRegex.test(url));

const extractYoutubeVideoID = (url) => url.match(youtubeEmbedRegex)[1];

const generateThumbnailImage = (videoId) => `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;

const playButton = (videoId) => `
<button class="${classNamesMap.playButton}" ${generateLoadAttribute(videoId)}>
  <span class="${classNamesMap.visuallyHidden}">Play</span>
</button>
`;

const thumbnailContainer = (videoId) => `
<img alt="video thumbnail" class="${classNamesMap.thumbnail}" src="${generateThumbnailImage(
  videoId,
)}" />
`;

const createLazyLoadFacade = (videoId) => `
<div class="${classNamesMap.wrapper}" ${rootContainerAttribute}>
  <div class="${classNamesMap.hoverOverlay}" ${clickReceiverAttribute}>
    ${thumbnailContainer(videoId)}
    ${playButton(videoId)}
  </div>
</div>
`;

const addAutoplayToUrl = (url) => {
  if (url.includes(autoplayQueryParameterActive)) {
    return url;
  }
  if (url.includes(autoplayQueryParameter)) {
    return url.replace(new RegExp(`${autoplayQueryParameter}=[^&]`), autoplayQueryParameterActive);
  }
  if (url.includes('?')) {
    return `${url}&${autoplayQueryParameterActive}`;
  }
  return `${url}?${autoplayQueryParameterActive}`;
};

const addIframeAllowAutoplay = (originalAllow = '') => {
  if (originalAllow.includes('autoplay')) {
    return originalAllow;
  }
  return [originalAllow, 'autoplay'].filter((allow) => allow.length > 0).join('; ');
};

const generateLazyLoadEmbed = (embed) => {
  const { allow, src } = embed.attribs;
  const videoId = extractYoutubeVideoID(src);
  const lazyLoadFacade = createLazyLoadFacade(videoId);
  return {
    iframe: {
      ...embed,
      attribs: {
        ...embed.attribs,
        allow: addIframeAllowAutoplay(allow),
        src: addAutoplayToUrl(src),
      },
    },
    lazyLoadFacade,
    videoId,
  };
};

// Module Exports
export {
  addAutoplayToUrl,
  addIframeAllowAutoplay,
  extractYoutubeVideoID,
  generateLazyLoadEmbed,
  generateThumbnailImage,
  isYoutubeEmbedLink,
};
